/** Seminar/ujian event mutations: schedule, committee, scores, results. */

import { createDoc, updateDoc } from '../service';
import { COL } from '../../collections';
import type { SkripsiDoc, SkripsiEventDoc } from '../../types';

export async function createEvent(data: {
  skripsiId: string;
  mahasiswaId: string;
  type: SkripsiEventDoc['type'];
  stage: SkripsiDoc['stage'];
  dateTime: string;
  room?: string;
  link?: string;
  moderatorId?: string;
  nomorSurat?: string;
  timPenguji?: NonNullable<SkripsiEventDoc['timPenguji']>;
}) {
  return createDoc<SkripsiEventDoc>(COL.events, {
    ...data,
    status: 'scheduled',
  });
}

export async function setEventResult(
  id: string,
  result: {
    nilaiAkhir?: number;
    keputusan?: 'lulus' | 'lulus_dengan_revisi' | 'tidak_lulus';
    catatan?: string;
  },
) {
  await updateDoc<SkripsiEventDoc>(COL.events, id, { result, status: 'completed' });
}

/** Snapshot the exam committee (pembimbing + penguji + moderator) on an event. */
export async function setEventCommittee(
  id: string,
  timPenguji: NonNullable<SkripsiEventDoc['timPenguji']>,
) {
  return updateDoc<SkripsiEventDoc>(COL.events, id, { timPenguji });
}

/** Store per-examiner scores + the aggregated final value. */
export async function setEventScores(
  id: string,
  scores: NonNullable<SkripsiEventDoc['scores']>,
  nilaiAkhirFinal?: number,
) {
  return updateDoc<SkripsiEventDoc>(COL.events, id, { scores, nilaiAkhirFinal });
}
